import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  panelHeader: {
    description: 'Header for the checklist',
    defaultMessage: "Let's Setup Your Inventory",
    id: 'LvWL2p',
  },
  panelInfo: {
    description: 'Information for the checklist',
    defaultMessage:
      'Get started by uploading and configuring your inventory, allowing you to easily track its storage locations and current stock quantities.',
    id: 'nz8Biu',
  },
  setupConfigurationTitle: {
    description: 'Step for setting up configurations',
    defaultMessage: 'Set up Configurations',
    id: 'GnbcxG',
  },
  setupConfigurationInfo: {
    description: 'Information for setting up configurations',
    defaultMessage: "Enable 'Inventory Tracking' within Configurations to allow Inventory to be managed within ShipStation.",
    id: 'z826/U',
  },
  establishWarehouseTitle: {
    description: 'Step for establishing a warehouse',
    defaultMessage: 'Establish a Warehouse',
    id: '05kqLZ',
  },
  establishWarehouseInfo: {
    description: 'Information for establishing a warehouse',
    defaultMessage: "Set your 'Ship From Location' within your Warehouses to help us define where your inventory is coming from.",
    id: '0jzVb5',
  },
  addInventoryCountTitle: {
    description: 'Step for adding inventory count',
    defaultMessage: 'Add Inventory Count',
    id: 'p+RMff',
  },
  addInventoryCountInfo: {
    description: 'Information for adding inventory count',
    defaultMessage: 'Upload your inventory count via CSV so we can start tracking your products.',
    id: '67fAFr',
  },
});
